var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechnicalSeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.7688 27.7302C56.7688 23.9902 53.7322 20.9479 49.9996 20.9479C46.267 20.9479 43.2305 23.9904 43.2305 27.7302C43.2305 28.2523 43.2881 28.7635 43.403 29.261H56.5964C56.7111 28.7635 56.7688 28.2521 56.7688 27.7302Z",
    fill: "url(#paint0_linear_4_32521)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5217 24.4193C70.0632 24.309 69.6421 24.079 69.3014 23.7528C68.9607 23.4267 68.7126 23.016 68.5823 22.5627C68.1794 21.1646 67.6144 19.8183 66.899 18.5513C66.6648 18.136 66.5462 17.6656 66.5555 17.1889C66.5648 16.7123 66.7017 16.2468 66.9519 15.841L69.2414 12.1274L65.9008 8.83789L62.0783 11.123C61.6783 11.3621 61.2227 11.4922 60.7569 11.5005C60.291 11.5087 59.8311 11.3948 59.4229 11.1701C58.1287 10.4573 56.7573 9.89473 55.3354 9.4932C54.8824 9.36548 54.4712 9.12015 54.1437 8.78212C53.8161 8.44409 53.5839 8.0254 53.4705 7.56856L52.4156 3.32031H47.6431L46.5928 7.55081C46.479 8.00895 46.2457 8.42869 45.9167 8.7672C45.5877 9.10572 45.1747 9.35087 44.72 9.47764C43.2969 9.87483 41.9238 10.4334 40.6276 11.1426C40.2199 11.3655 39.7611 11.4781 39.2965 11.4692C38.832 11.4602 38.3778 11.3301 37.979 11.0917L34.1409 8.7972L30.8003 12.0867L33.0804 15.7848C33.3313 16.1917 33.4683 16.6587 33.4769 17.1367C33.4855 17.6147 33.3654 18.0863 33.1293 18.502C32.4102 19.7669 31.8412 21.1115 31.4341 22.5085C31.3027 22.96 31.0544 23.3688 30.7143 23.6934C30.3741 24.018 29.9542 24.247 29.497 24.3571L25.1694 25.399V29.2611H37.9943C37.9298 28.7533 37.897 28.242 37.8962 27.7302C37.8962 21.0488 43.326 15.613 50.0002 15.613C56.6744 15.613 62.1042 21.0488 62.1042 27.7302C62.1042 28.2467 62.0695 28.7568 62.0061 29.2611H74.831V25.4567L70.5217 24.4193ZM3.32031 84.3971V94.8404C3.32031 95.8544 4.14539 96.6797 5.15957 96.6797H94.8404C95.8546 96.6797 96.6797 95.8546 96.6797 94.8404V84.3971H67.5645L65.5358 89.4312C65.337 89.9245 64.9952 90.3472 64.5543 90.6448C64.1134 90.9425 63.5937 91.1015 63.0617 91.1015H36.8904C36.3585 91.1015 35.8387 90.9425 35.3978 90.6448C34.957 90.3472 34.6152 89.9245 34.4164 89.4312L32.3874 84.3971H3.32031Z",
    fill: "url(#paint1_linear_4_32521)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7758 34.5957H12.2245C11.244 34.5957 10.4463 35.3934 10.4463 36.3739V79.0623H34.1887C34.7206 79.0623 35.2404 79.2213 35.6813 79.5189C36.1221 79.8166 36.4639 80.2392 36.6627 80.7326L38.6917 85.7666H61.2613L63.2903 80.7326C63.4891 80.2392 63.8309 79.8166 64.2718 79.519C64.7126 79.2214 65.2324 79.0623 65.7643 79.0623H89.5542V36.3741C89.5542 35.3934 88.7565 34.5957 87.7758 34.5957ZM40.6091 53.725L30.9131 58.5851L40.6091 63.4451V68.5608L24.3951 60.2097V56.9601L40.6091 48.609V53.725ZM48.3376 68.8381H43.4397L52.5925 45.0553H57.523L48.3376 68.8381ZM75.6051 60.2406L59.3911 68.5566V63.4424L69.1554 58.5849L59.3911 53.7274V48.6136L75.6051 56.9295V60.2406Z",
    fill: "url(#paint2_linear_4_32521)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_32521",
    x1: 43.2305,
    y1: 21.0274,
    x2: 52.0658,
    y2: 35.6898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_32521",
    x1: 3.32031,
    y1: 4.21368,
    x2: 115.527,
    y2: 118.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_32521",
    x1: 10.4463,
    y1: 35.0854,
    x2: 66.1102,
    y2: 122.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicalSeo);
export default __webpack_public_path__ + "static/media/Technical-Seo.a8431783bb1fdc4a43fa4ec2128abda6.svg";
export { ForwardRef as ReactComponent };